import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IGetGroupDetailInfoResult, IGroupInfo } from '../../ts/models/IGroupInfo';
import { Resource } from '../../ts/resources/Resource';
import { CreateGroupRequest, ICreateGroupParams } from '../../ts/ServerApi/requests/CreateGroupRequest';
import { DeleteGroupsRequest } from '../../ts/ServerApi/requests/DeleteGroupsRequest';
import { GetGroupDetailsRequest, IGetGroupDetailsParams } from '../../ts/ServerApi/requests/GetGroupDetailsRequest';
import { GetGroupsRequest } from '../../ts/ServerApi/requests/GetGroupsRequest';
import { GrantLicenseModes } from '../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { IUpdateGroupNameParams, UpdateGroupNameRequest } from '../../ts/ServerApi/requests/UpdateGroupNameRequest';
import { UpdateGroupsMinimumSiteRoleRequest } from '../../ts/ServerApi/requests/UpdateGroupsMinimumSiteRoleRequest';

function getErrorNotifyingServer(): WebHttpClientWithErrorToast {
  return WebHttpClientWithErrorToastInstance;
}

export class GroupsResource extends Resource<IGroupInfo> {

  constructor() {
    super(new WebClientListResourceFetcher(GetGroupsRequest, ServerApiMapper.groups));
  }

  // Actions


  // create new group
  public createGroup(groupName: string, grantLicenseMode?: GrantLicenseModes, minimumSiteRole?: string): Promise<IResult> {
    const params: ICreateGroupParams = {
      name: groupName,
      grantLicenseMode: grantLicenseMode,
      siteRole: minimumSiteRole
    };
    return getErrorNotifyingServer().sendRequestAndDelay(new CreateGroupRequest(params));
  }

  // delete groups
  public deleteGroups(ids: string[]): Promise<IResult> {
    return getErrorNotifyingServer().sendRequestsAndDelay(
        RequestHelper.buildRequests(ids, (idsBlock) => new DeleteGroupsRequest(idsBlock)),
        ResultHelper.combineResults);
  }

  // update group name
  public updateGroupName(groupId: string, name: string): Promise<IResult> {
    const params: IUpdateGroupNameParams = {
      groupId: groupId,
      name: name
    };
    return getErrorNotifyingServer().sendRequestAndDelay(new UpdateGroupNameRequest(params));
  }

  // get group details
  public getGroupDetails(groupId: string): Promise<IGetGroupDetailInfoResult> {
    const params: IGetGroupDetailsParams = {
      id: groupId
    };
    return WebHttpClient.sendRequest(new GetGroupDetailsRequest(params)).then((result) => {
      const groupInfo: IGetGroupDetailInfoResult = {
        ...result,
        contentType: 'group'
      };
      return groupInfo;
    });
  }

  public updateGroupsMinimumSiteRole(groupIds: string[], siteRole: string, grantLicenseMode: GrantLicenseModes): Promise<IResult> {
    return getErrorNotifyingServer().sendRequestsAndDelay(
        RequestHelper.buildRequests(groupIds, (idsBlock) => {
          return new UpdateGroupsMinimumSiteRoleRequest({
            groupIds: idsBlock,
            minimumSiteRole: siteRole,
            grantLicenseMode: grantLicenseMode
          });
        }),
        ResultHelper.combineResults
      );
  }

}

export const Groups = new GroupsResource;
